import * as Icons from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";

const iconNames = ["Sparkles", "Droplet", "Circle", "Gem", "Grip", "Copy"];

export default function QualityDetails() {
  const { t } = useLanguage();
  return (
    <section data-testid="quality-section" className="bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-6xl px-5 lg:px-10">
        <Reveal className="mb-12 text-center">
          <h2 className="font-serif-display text-3xl font-medium text-[#111] sm:text-4xl">{t.quality.title}</h2>
        </Reveal>
        <div className="grid grid-cols-2 gap-6 lg:grid-cols-3">
          {t.quality.blocks.map(([title, text], i) => {
            const Icon = Icons[iconNames[i]] || Icons.Gem;
            return (
              <Reveal key={title} delay={(i % 3) * 0.08}>
                <div data-testid={`quality-block-${i}`} className="rounded-2xl border border-[#eee] p-6">
                  <Icon className="h-6 w-6 text-[#111]" strokeWidth={1.3} />
                  <h3 className="mt-4 font-body text-base font-medium text-[#111]">{title}</h3>
                  <p className="mt-1 font-body text-sm text-[#777]">{text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
